export type WorkspaceBranding = {
  name: string
  subdomain: string
  logo: { id: number; url: string } | null
  primary_color: string | null
}

export type MyWorkspaceMembership = {
  role: "admin" | "member"
  workspace: WorkspaceBranding
}

export function computeIsAdminHere(
  myWorkspaces: MyWorkspaceMembership[],
  currentSubdomain: string | undefined
): boolean {
  if (!currentSubdomain) {
    return false
  }
  return myWorkspaces.some(
    (membership) =>
      membership.workspace.subdomain === currentSubdomain &&
      membership.role === "admin"
  )
}

export function otherActiveWorkspaces(
  myWorkspaces: MyWorkspaceMembership[],
  currentSubdomain: string | undefined
): MyWorkspaceMembership[] {
  if (!currentSubdomain) {
    return myWorkspaces
  }
  return myWorkspaces.filter(
    (membership) => membership.workspace.subdomain !== currentSubdomain
  )
}
